/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { TLayoutItem } from '../../types/layout';
import Table from '../../components/table';
import Card from '../../components/card';
import Form from '../../components/form';
import LayoutItemWrapper from '../../components/layout-item-wrapper';
import Tabs from '../../components/tabs';
import ActionButton from '../../components/action-button';
import ChangeHistory from '../../components/change-history';
import Commentaries from '../../components/commentaries';
import Kanban from '../../components/kanban';
import Html from '../../components/html';
import { INestedLayoutParams } from '../../types/components';
import Button from '../../components/button';
import Chart from '../../components/chart';
import InfoBox from '../../components/box';
import ActionModal from '../../components/action-modal';
import Calendar from '../../components/calendar';

export interface ILayoutWithOwner {
    idOwner?: string | number;
}

export interface ILayoutWithRowId {
    rowId?: string | number;
}

type ILayoutFactoryProps = {
    layout: TLayoutItem[];
    data?: any;
} & ILayoutWithOwner & ILayoutWithRowId & INestedLayoutParams;

function LayoutFactory({
    idOwner, layout, data, rowId, nestedParams,
}: ILayoutFactoryProps) {
    const renderComponent = (item: TLayoutItem) => {
        switch (item.type) {
            case 'action': {
                return (
                    <ActionButton {...item} idOwner={idOwner} rowId={rowId} />
                );
            }
            case 'action-modal': {
                return (
                    <ActionModal {...item} idOwner={idOwner} />
                );
            }
            case 'button': {
                return (
                    <Button {...item} />
                );
            }
            case 'calendar': {
                return (
                    <Calendar {...item} />
                );
            }
            case 'card': {
                return (
                    <Card {...item}>
                        <LayoutFactory
                            layout={item.elements}
                            nestedParams={nestedParams || { idOwner, rowId }}
                            idOwner={idOwner}
                            rowId={rowId}
                        />
                    </Card>
                );
            }
            case 'chart': {
                return (
                    <Chart {...item} />
                );
            }
            case 'table': {
                return (
                    <Table {...item} />
                );
            }
            case 'form': {
                return (
                    <Form {...item} nestedParams={nestedParams || { idOwner, rowId }} />
                );
            }
            case 'tabs': {
                return (
                    <Tabs {...item} rowId={rowId} />
                );
            }
            case 'change-history': {
                return (
                    <ChangeHistory {...item} />
                );
            }
            case 'commentaries': {
                return (
                    <Commentaries {...item} rowId={rowId} />
                );
            }
            case 'kanban': {
                return (
                    <Kanban {...item} data={data} actions={{ edit: 'edit', drop: 'drop' }} />
                );
            }
            case 'html': {
                return (
                    <Html {...item} />
                );
            }
            case 'info-box': {
                return (
                    <InfoBox {...item} />
                );
            }
            default: {
                return null;
            }
        }
    };

    const renderLayout = (layoutItem: TLayoutItem[]) => React.Children.toArray(layoutItem.map((item) => (
        <LayoutItemWrapper breakpointColumn={item.breakpointColumn} dependingFieldsValues={item.dependingFieldsValues}>
            {renderComponent(item)}
        </LayoutItemWrapper>
    )));

    if (Array.isArray(layout)) {
        return (
            <div className="row">
                {renderLayout(layout)}
            </div>
        );
    }

    return null;
}

LayoutFactory.defaultProps = {
    idOwner: undefined,
    rowId: undefined,
    data: {},
};

export default LayoutFactory;
